module.exports = __webpack_public_path__ + "media/images/flags/64/Andorra-764cd9c23851f4d39b3fa044161ced20.png";